import { render } from "./MainSlider.vue?vue&type=template&id=e28f5ae6&scoped=true"
import script from "./MainSlider.vue?vue&type=script&lang=js"
export * from "./MainSlider.vue?vue&type=script&lang=js"

import "./MainSlider.vue?vue&type=style&index=0&id=e28f5ae6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e28f5ae6"]])

export default __exports__